module.exports = __webpack_public_path__ + "img/socupv1green.3fcfe142.svg";